export default {
  brand: "USFansLink",
  nav: {
    spreadsheets: "Tableurs",
    products: "Produits",
    sellers: "Vendeurs",
    reviews: "Avis",
    shipping: "Livraison",
    coupons: "Coupons",
    guides: "Guides",
    safety: "Sécurité",
    buyNow: "Acheter maintenant",
    home: "Accueil",
    shoppingGuide: "Guide d'achat",
    categories: "Catégories",
    chooseLanguage: "Langue",
  },
  hero: {
    badge: "Ressource indépendante • Guides actualisés • Support multilingue",
    title: "Tableur USFans – Trouvez produits, vendeurs et guides d'achat",
    subtitle:
      "Explorez le tableur USFans pour découvrir des listes de produits utiles, des ressources vendeurs, des guides d'achat, des informations de livraison, des conseils de contrôle qualité et les dernières ressources USFans, le tout organisé dans un hub facile à utiliser.",
    ctaPrimary: "Tableur USFans",
    ctaSecondary: "Acheter maintenant",
    hint: "Ouvre la boutique officielle USFans dans un nouvel onglet",
  },
  categories: {
    title: "Parcourez les produits par catégorie",
    subtitle:
      "Accédez directement à la catégorie dont vous avez besoin. Chaque lien ouvre la boutique USFans pour que vous puissiez continuer vos achats sans tracas.",
    dropdownLabel: "Choisir une catégorie",
    dropdownPlaceholder: "Sélectionnez une catégorie…",
    openLabel: "Voir la catégorie",
    shoes: "Chaussures",
    hoodies: "Sweats et pulls",
    tshirts: "T-shirts",
    jackets: "Vestes",
    pants: "Pantalons et shorts",
    headwear: "Casquettes et chapeaux",
    sets: "Ensembles",
    underwear: "Sous-vêtements et caleçons",
    jerseys: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres",
  },
  resources: {
    title: "Tout ce qu'il faut pour rechercher des produits USFans",
    subtitle:
      "Chercher des produits, des vendeurs ou des informations utiles sur USFans peut prendre du temps. USFansLink organise les ressources importantes en tableurs, guides, comparatifs et tutoriels clairs pour que vous recherchiez les produits plus efficacement et preniez de meilleures décisions.",
    cards: {
      spreadsheet: { title: "Tableur USFans", desc: "Informations produits et vendeurs organisées dans une vue claire et filtrable." },
      productLists: { title: "Listes de produits", desc: "Des listes sélectionnées pour comparer rapidement les articles entre catégories." },
      sellerGuides: { title: "Guides vendeurs", desc: "Conseils pratiques pour rechercher les vendeurs et lire leur historique." },
      shippingGuides: { title: "Guides de livraison", desc: "Explications claires des options, coûts et délais de livraison." },
      qcResources: { title: "Ressources contrôle qualité", desc: "Listes de contrôle et conseils photo pour vérifier la qualité avant d'acheter." },
      safetyGuides: { title: "Guides de sécurité", desc: "Sécurité du compte, liens suspects et vigilance de paiement au même endroit." },
    },
  },
  spreadsheet: {
    title: "Tableur USFans",
    text: "Commencez par le tableur USFans pour explorer des informations organisées sur les produits et les vendeurs. Utilisez les filtres, les catégories et les guides d'appui pour affiner ce que vous cherchez avant de décider.",
    cta: "Ouvrir le guide du tableur",
  },
  popular: {
    title: "Ressources USFans populaires",
    subtitle: "Accès rapide aux sujets les plus recherchés par les acheteurs.",
    comingSoon: "Guide bientôt disponible",
    cards: {
      review: { title: "Avis USFans", desc: "Un regard indépendant sur les fonctions, le parcours d'achat et l'expérience globale." },
      shippingCost: { title: "Frais de livraison USFans", desc: "Comment les options et coûts de livraison varient selon la destination." },
      coupon: { title: "Coupon USFans", desc: "Où chercher les offres actuelles et comment les appliquer." },
      discountCode: { title: "Code promo USFans", desc: "Conseils pour trouver les offres disponibles avant le paiement." },
      warehouse: { title: "Entrepôt USFans", desc: "Comment le stockage et les processus d'entrepôt affectent la livraison." },
      legit: { title: "USFans est-il légitime ?", desc: "Un guide équilibré sur la confiance et la sécurité." },
    },
  },
  confidence: {
    title: "Recherchez des produits avec plus de confiance",
    text: "Utilisez ensemble les informations produit, la recherche vendeurs, les ressources de contrôle qualité et les guides de livraison au lieu de vous fier à une seule source. Notre objectif est de rendre le processus de recherche plus facile à comprendre.",
  },
  shipping: {
    title: "Guides de livraison, d'entrepôt et de suivi USFans",
    text: "Découvrez comment les options de livraison, les processus d'entrepôt et les considérations de suivi peuvent affecter votre expérience d'achat.",
    cta: "Explorer les guides de livraison",
  },
  review: {
    title: "Avis et guide d'expérience USFans",
    text: "Vous cherchez un avis USFans ? Explorez nos guides indépendants couvrant les fonctions de la plateforme, le parcours d'achat, la livraison, les informations d'entrepôt, les considérations de sécurité et les questions courantes.",
    cta: "Lire l'avis USFans",
  },
  safety: {
    title: "Centre de sécurité USFans",
    text: "Avant d'utiliser une plateforme d'achat ou une ressource vendeur, comprenez les risques potentiels. Notre Centre de Sécurité couvre la sécurité du compte, la recherche vendeurs, les contrôles qualité, la vigilance de paiement, les considérations de livraison et les liens suspects.",
    cta: "Visiter le Centre de Sécurité",
  },
  guides: {
    title: "Derniers guides du tableur USFans",
    subtitle: "Des guides frais et originaux pour vous aider à mieux rechercher.",
    readMore: "Lire le guide",
    article: {
      title: "Qu'est-ce que le tableur USFans ? Guide complet",
      excerpt:
        "Découvrez ce qu'est le tableur USFans, ce qu'il contient, comment l'utiliser pour trouver produits et vendeurs, et ce qu'il faut savoir sur la livraison, le contrôle qualité et la sécurité avant d'acheter.",
      tag: "Guide débutant",
    },
    moreSoon: "D'autres guides arrivent bientôt : livraison, coupons, entrepôt et avis détaillés.",
  },
  faq: {
    title: "Questions fréquentes",
    subtitle: "Des réponses rapides aux questions les plus posées sur le tableur USFans.",
    questions: {
      q1: "Qu'est-ce qu'un tableur USFans ?",
      a1: "C'est une ressource organisée qui réunit les listes de produits, les informations vendeurs et les catégories dans une seule vue, pour comparer les options sans sauter entre de nombreuses pages.",
      q2: "Comment utiliser un tableur USFans ?",
      a2: "Choisissez une catégorie, puis filtrez ou triez les colonnes qui vous intéressent, comme le prix ou la livraison. Une fois vos options affinées, suivez les liens produits pour continuer sur la boutique principale.",
      q3: "USFans est-il légitime ?",
      a3: "USFans est une plateforme d'achat utilisée par de nombreux acheteurs. Comme dans toute boutique, recherchez les vendeurs, consultez les photos de contrôle qualité et méfiez-vous des demandes de paiement inhabituelles avant d'acheter.",
      q4: "Combien coûte la livraison USFans ?",
      a4: "Les frais de livraison varient selon le vendeur, la destination et la méthode. Confirmez toujours le coût final dans la colonne livraison ou au paiement avant de passer commande.",
      q5: "USFans propose-t-il des coupons ?",
      a5: "Les offres et codes promo vont et viennent. Consultez les dernières ressources de coupons et de codes avant le paiement, car un code peut ne fonctionner que pour certaines catégories ou commandes minimales.",
      q6: "Où se trouve l'entrepôt USFans ?",
      a6: "Les emplacements et processus d'entrepôt peuvent varier. Consultez les notes d'entrepôt du vendeur chez qui vous achetez pour comprendre les délais de stockage et de livraison.",
      q7: "Comment rechercher les vendeurs USFans ?",
      a7: "Vérifiez l'historique du vendeur, lisez les avis, regardez les photos de contrôle qualité lorsqu'elles sont disponibles et confirmez les détails de livraison et de paiement avant de décider d'acheter.",
    },
  },
  finalCta: {
    title: "Commencez votre recherche USFans",
    text: "Explorez le tableur USFans, comparez les ressources utiles et poursuivez votre recherche de produits avec nos derniers guides.",
    cta: "Explorer le tableur USFans",
  },
  notFound: {
    title: "Cette page n'a pas encore été générée",
    subtitle: "Parlez-nous davantage de cette page et nous la générerons pour vous.",
    backHome: "Revenir à l'accueil",
  },
  footer: {
    about: "À propos",
    contact: "Contact",
    privacy: "Politique de confidentialité",
    terms: "Conditions",
    editorial: "Politique éditoriale",
    updates: "Actualités",
    disclaimer:
      "USFansLink est une ressource d'information indépendante et n'est pas affiliée ni approuvée par USFans, sauf indication explicite.",
    rights: "Tous droits réservés.",
  },
};